import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ReactGA from 'react-ga4';

const rootElement = document.getElementById('root');
const searchType = rootElement?.getAttribute('data-search-type');
const developerMode = rootElement?.getAttribute('data-developer-mode');
const GA4_MEASUREMENT_ID_DEVELOPMENT =
  process.env.REACT_APP_GA4_MEASUREMENT_ID_DEVELOPMENT;
const GA4_MEASUREMENT_ID_PRODUCTION =
  process.env.REACT_APP_GA4_MEASUREMENT_ID_PRODUCTION;

if (window.location.hostname === 'historicengland.org.uk') {
  if (GA4_MEASUREMENT_ID_PRODUCTION) {
    ReactGA.initialize(GA4_MEASUREMENT_ID_PRODUCTION);
  }
} else {
  if (GA4_MEASUREMENT_ID_DEVELOPMENT) {
    console.log(GA4_MEASUREMENT_ID_DEVELOPMENT);
    ReactGA.initialize(GA4_MEASUREMENT_ID_DEVELOPMENT);
  }
}

const root = createRoot(rootElement);
root.render(<App developerMode={developerMode} searchType={searchType} />);
